// Die drei Ansichten der Übersicht „Alte Kundenakten" (01.10.2026): Noch
// offen | Zugewiesen | Nicht benötigt. Rein und ohne React, damit die Regel,
// wann eine Zeile nach einer Aktion aus der Liste fällt, direkt testbar ist.
//
// Dieselbe Regel steht serverseitig in `kundenaktenFolder.service.ts`
// (Parameter `ansicht`). Mit Suchbegriff gilt KEINE Ansicht: gesucht wird über
// alle Zustände, auch zugewiesene und nicht benötigte Ordner — die Zeile zeigt
// dann ihren Zustand. „Fehlt am Share" erscheint nie.

import type { Folder, Stats } from "./types";

export type Ansicht = "offen" | "zugewiesen" | "nichtBenoetigt";

export const ANSICHTEN: ReadonlyArray<{ key: Ansicht; label: string; statsKey: keyof Stats }> = [
  { key: "offen", label: "Noch offen", statsKey: "offen" },
  { key: "zugewiesen", label: "Zugewiesen", statsKey: "zugewiesen" },
  { key: "nichtBenoetigt", label: "Nicht benötigt", statsKey: "nichtBenoetigt" },
];

/** Ist der Ordner zugewiesen? Haupt- oder Zusatzkontakt genügt. */
export const istZugewiesen = (f: Folder): boolean => !!f.contact?.id || (f.weitereKontakte ?? []).length > 0;

/** Gehört die Zeile nach einer Aktion noch in die aktive Ansicht? */
export const passtZurAnsicht = (ansicht: Ansicht, suche: string, f: Folder): boolean => {
  if (f.missing) return false;
  if (suche.trim()) return true;
  if (ansicht === "nichtBenoetigt") return !!f.notNeeded;
  if (f.notNeeded) return false;
  return ansicht === "zugewiesen" ? istZugewiesen(f) : !istZugewiesen(f);
};
